import { render, staticRenderFns } from "./galleryHeatMap.vue?vue&type=template&id=970ea6e8&scoped=true&"
import script from "./galleryHeatMap.vue?vue&type=script&lang=js&"
export * from "./galleryHeatMap.vue?vue&type=script&lang=js&"
import style0 from "./galleryHeatMap.vue?vue&type=style&index=0&id=970ea6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970ea6e8",
  null
  
)

export default component.exports